import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  // Field2 as Field,
  color,
  GlobalActions,
  LocationHelper,
  TimeUtil,
  VibeButton,
  viPlayCircleOutline,
} from 'vibeguide';
import {
  toNumber,
} from 'lodash';
import {
  Grid,
} from '@mui/material';
import LoopDefinitionItem from './LoopDefinitionItem';
import LoopMedia from './LoopMedia';

class LoopDefinition extends PureComponent {
  onAddMedia = (data) => {
    const {
      onUpdate,
      messages,
    } = this.props;

    // filter out doubles
    const updatedData = data.filter((message) => {
      return !messages.some((item) => message._id === item._id);
    });

    const mergedMessages = [
      ...messages,
      ...updatedData,
    ];

    onUpdate({
      messages: mergedMessages,
    });
  };

  onAddCreative = () => {
    const {
      setPanel,
      locations,
    } = this.props;

    setPanel({
      extraPanel: {
        show: true,
        backdrop: false,
        width: window.innerWidth,
        children: (
          <LoopMedia
            locations={LocationHelper.group(locations)}
            onAddMedia={this.onAddMedia}
          />
        ),
      },
    });
  };

  render() {
    const {
      locations,
      mediaItems,
      onUpdateItem,
      onRemoveItem,
      onChangeItemOrder,
    } = this.props;

    const disableMedia = locations.length <= 0;

    const totalLoopTime = mediaItems?.reduce((accumulator, mediaItem) => {
      return accumulator + toNumber(mediaItem.durationSeconds);
    }, 0) || 0;

    const totalLoopMinutesSeconds = TimeUtil.convertSeconds(totalLoopTime).split(':');

    // const canSetCompany = user.sysAdmin;

    return (
      <div className="LoopDefinition">
        <Grid
          className="row"
          spacing={2}
          container
        >

          <Grid
            xs={12}
            item
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                className="creative-btn"
                style={{
                  border: '1px solid #333F48',
                  padding: '8px',
                  borderRadius: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  flexGrow: 1,
                }}
              >
                <VibeButton
                  className="custom-button"
                  style={{
                    marginRight: 8,
                    borderRadius: 16,
                    border: 'none',
                    height: '22px',
                  }}
                  text="Add Media"
                  iconProps={{
                    style: {
                      color: color.whiteSmoke,
                    },
                  }}
                  color="secondary"
                  icon={viPlayCircleOutline}
                  tabIndex={5}
                  onClick={this.onAddCreative}
                  disabled={disableMedia}
                />
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid
          className="row"
          spacing={2}
          container
        >
          <Grid
            xs={12}
            style={{
              textAlign: 'right',
              marginTop: 8,
              marginBottom: 8,
            }}
            item
          >
            { mediaItems.length > 0
              /* eslint-disable-next-line max-len */
              && `Total Loop Duration: ${parseInt(totalLoopMinutesSeconds[0], 10)} min ${totalLoopMinutesSeconds[1]} seconds` }
          </Grid>
        </Grid>
        <Grid
          className="row"
          spacing={2}
          container
        >
          <Grid
            xs={12}
            item
          >
            {mediaItems.map((item, i) => (
              <LoopDefinitionItem
                key={`item-${item._id}`}
                item={item}
                index={i}
                onUpdate={onUpdateItem}
                onRemove={onRemoveItem}
                onChangeOrder={onChangeItemOrder}
              />
            ))}
          </Grid>
        </Grid>
        <Grid
          className="row"
          spacing={2}
          container
        >
          <Grid
            xs={12}
            style={{
              textAlign: 'right',
              marginTop: 8,
              marginBottom: 8,
            }}
            item
          >
            { mediaItems.length > 0
              /* eslint-disable-next-line max-len */
              && `Total Loop Duration: ${parseInt(totalLoopMinutesSeconds[0], 10)} min ${totalLoopMinutesSeconds[1]} seconds` }
          </Grid>
        </Grid>
      </div>
    );
  }
}

LoopDefinition.propTypes = {
  mediaItems: PropTypes.arrayOf(PropTypes.object),
  locations: PropTypes.arrayOf(PropTypes.object),
  onUpdateItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
  onChangeItemOrder: PropTypes.func,
  onUpdate: PropTypes.func,
};

LoopDefinition.defaultProps = {
  mediaItems: PropTypes.arrayOf(PropTypes.object),
  locations: [],
  onUpdateItem: () => {},
  onRemoveItem: () => {},
  onChangeItemOrder: () => {},
  onUpdate: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoopDefinition);
